import * as React from 'react';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import { CartEntryType } from 'utils/cart/types';
import priceForCartEntry from 'utils/menu/price-for-cart-entry';

import { EntryDescriptionRow } from './cart-entry.styled';

const resolveEntryChild = (entry: IBackendCartEntries, showAllPrices: boolean) => {
  if (!entry.children) {
    return null;
  }

  const resolveChild = (child: IBackendCartEntries, i: number): React.ReactNode =>
    child?.children?.length ? (
      child.children.map(resolveChild)
    ) : (
      <EntryDescriptionRow key={child.name! + i}>
        {child.name}
        {(child.type === CartEntryType.itemOptionModifier || showAllPrices) &&
          Boolean(child?.price) && (
            <>
              &nbsp; - &nbsp;
              <Currency amount={priceForCartEntry(child)} />
            </>
          )}
      </EntryDescriptionRow>
    );

  return entry.children.map(resolveChild);
};

export default resolveEntryChild;
